import { Directive, input, output } from '@angular/core';

@Directive({
  selector: '[appA11yPress]',
  host: {
    '[attr.tabindex]': 'focusable() ? 0 : -1',
    '(keydown.space)': "onPress($event, 'space')",
    '(keydown.enter)': "onPress($event, 'enter')",
    '(click)': "onPress($event, 'click')"
  }
})
export class A11yPressDirective {
  readonly allowedEvents = input(['space', 'enter', 'click']);
  readonly focusable = input(true);
  readonly press = output<KeyboardEvent | MouseEvent>();

  public onPress(event: KeyboardEvent | MouseEvent, eventToCheck: string) {
    event.stopPropagation();
    if (this.allowedEvents().includes(eventToCheck)) this.press.emit(event);
  }
}
